import { jsx as _jsx } from "react/jsx-runtime";
import { useState } from 'react';
import { SvgIcon, SvgIconType } from '@integration-app/react';
import clsx from 'clsx';
import classes from './IntegrationIcon.module.css';
export function IntegrationIcon({ integration, size = 'md', className, variant = 'rounded', onClick, }) {
    const [error, setError] = useState(false);
    if (!integration)
        return null;
    const style = typeof size === 'number' ? { width: size, height: size } : undefined;
    const classNames = clsx(!error && classes.image, error && classes.image_placeholder, variant === 'rounded' && classes.image__rounded, size === 'sm' && classes.image__sm, size === 'md' && classes.image__md, size === 'lg' && classes.image__lg, size === 'xl' && classes.image__xl, !!onClick && 'cursor-pointer border border-white hover:shadow', className);
    if (error) {
        return _jsx("div", { className: classNames, style: style });
    }
    if (integration === null || integration === void 0 ? void 0 : integration.logoUri) {
        return (_jsx("img", { onClick: () => onClick === null || onClick === void 0 ? void 0 : onClick(), className: classNames, style: style, src: integration === null || integration === void 0 ? void 0 : integration.logoUri, alt: integration === null || integration === void 0 ? void 0 : integration.name, onError: () => setError(true) }));
    }
    return (_jsx(SvgIcon, { className: classNames, type: SvgIconType.DefaultWorkspaceIcon }));
}
export function DefaultIntegrationIcon({ size = 'md', variant = 'rounded', className, }) {
    const classNames = clsx(variant === 'rounded' && classes.image__rounded, size === 'sm' && classes.image__sm, size === 'md' && classes.image__md, size === 'lg' && classes.image__lg, size === 'xl' && classes.image__xl, className);
    return (_jsx(SvgIcon, { className: classNames, type: SvgIconType.DefaultWorkspaceIcon }));
}
//# sourceMappingURL=index.js.map